<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="custom-popup" style="width: 400px;">
      <div class="popup-header" style="width: 400px;">
        <table>
          <thead>
            <th>
              <h3>
                <span class="moderat-meGreen-bold">Site Name: {{ getCentralSiteTitle() }}</span>
              </h3>
            </th>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>
                  <span class="moderat-meGreen">Motion Site ID: {{ getCentralSiteGroupID() }}</span>
                </p>
                <p>
                  <span class="moderat-meGreen">Customer: {{ getCentralSiteCustomer() }}</span>
                </p>
                <p>
                  <span class="moderat-meGreen">Address: {{ getCentralSiteAddress() }}</span>
                </p>
                <p>
                  <span class="moderat-meGreen">Postcode: {{ getCentralSitePostcode() }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="line-312">
        <svg style="width: 100%; height: 1px;">
            <use href="@/assets/svg/newSvgIcon.svg#line312"></use>
        </svg>
      </div>
      <div class="popup-body">
        <p class="moderat-meGreen-bold-12">Nearby Sites (within 100m)</p>
      </div>
      <div class="chargers" v-if="showCharger" :v-loading="loading" style="width: 400px;">
        <table class="styled-table w-100">
          <thead>
            <th>
              <span class="moderat-white-bold-12">Customer</span>
            </th>
            <th>
              <span class="moderat-white-bold-12">Site Name</span>
            </th>
            <th>
              <span class="moderat-white-bold-12">Postcode</span>
            </th>
            <th>
              <span class="moderat-white-bold-12">Distance(m)</span>
            </th>
          </thead>
          <tbody>
            <tr v-for="(site, index) in getNearbySites()" :key="index">
              <td>
                <span class="moderat-meGreen-12">{{ site.full_name }}</span>
              </td>
              <td>
                <span class="moderat-meGreen-12">{{ site.site_name }}</span>
              </td>
              <td>
                <span class="moderat-meGreen-12">{{ site.postcode }}</span>
              </td>
              <td>
                <span class="moderat-meGreen-12">{{ site.distance_m }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="popup-footer">
        <el-button
          @click="handleClick"
          class="view-more"
          link
          style="cursor: pointer"
        >
          {{ showCharger ? "View less" : "View more" }}
        </el-button>
      </div> -->
    </div>
  </template>
  
  <script>

  export default {
    props: {
      popupData: Object,
    },
    data() {
      return {
        loading: false,
        showCharger: true,
      };
    },
    
    methods: {
      // handleClick() {
      //   this.showCharger = !this.showCharger;
      // },
      getCentralSiteTitle() {
        return this.popupData.central_site_title;
      },
      getCentralSiteCustomer() {
        return this.popupData.central_site_full_name;
      },
      getCentralSiteGroupID() {
        return this.popupData.central_site_group_id;
      },
      getNearbySites() {
        return this.popupData.nearby_sites;
      },
      getCentralSiteAddress() {
        return this.popupData.central_site_address;
      },
      getCentralSitePostcode() {
        return this.popupData.central_site_postcode;
      }
    },
  };
  </script>
  
  <style>
  
  </style>
  